import * as dto from "./dashboard.dto";
import { WidgetKind } from "./dashboard.dto";
export { DashboardLayoutKind, WidgetKind } from "./dashboard.dto";

export class Dashboard {

    static createFrom(d: dto.Dashboard) {
        let result = Object.assign(new Dashboard(), d);

        result.columns = [];
        let colIndex = -1;
        for (let c of (d.columns || [])) {
            colIndex++;
            result.columns[colIndex] = [];
            for (let w of (c || [])) {
                const widget = Widget.create(w.component, w.configuration);
                if (widget && widget.component) {
                    result.columns[colIndex].push(widget);
                }
            }
        }

        return result;
    }

    layout: dto.DashboardLayoutKind;
    columns: Widget[][];
    id: string;
    title: string;
    urlPart: string;

    addWidget(widget: WidgetKind, column: number): void {
        const w = Widget.create(widget, "");
        this.columns[column].push(w);
    }

    deleteWidget(w: Widget) {
        const component = w.component;
        this.columns.forEach((column, index) => {
            let newArray = column.filter((widget) => {
                return widget.component !== component;
            });
            this.columns[index] = newArray;
        });
    }

    save(): Promise<Dashboard> {
        throw new Error("Not Implemented");
    }

    getDto(): dto.Dashboard {
        let result: dto.Dashboard = Object.assign({}, this);
        result.columns = this.columns.map(c => c.map(w => ({ component: w.component, configuration: Object.assign(w) })));
        return result;
    }
}

export abstract class Widget {

    abstract get component(): dto.WidgetKind;
    abstract title: string;

    static create(component: dto.WidgetKind, conf: any): Widget {
        switch (component) {
            case (dto.WidgetKind.Chart): return new ChartWidget(conf);
            case (dto.WidgetKind.Map): return new MapWidget(conf);
            case (dto.WidgetKind.WorkOrder): return new WorkOrderWidget(conf);
            case (dto.WidgetKind.FullCalendar): return new FullCalendarWidget(conf);
            case (dto.WidgetKind.ListCalendar): return new ListCalendarWidget(conf);
            case (dto.WidgetKind.RegistrationRequest): return new RegistrationRequestWidget(conf);
            case (dto.WidgetKind.FinancialAssurance): return new FinancialAssuranceWidget(conf);
            case (dto.WidgetKind.Permits): return new PermitsWidget(conf);
            case (dto.WidgetKind.ExternalPermit): return new ExternalPermitWidget(conf);
            case (dto.WidgetKind.ExternalWorkOrder): return new ExternalWorkOrder(conf);
            case (dto.WidgetKind.PendingMail): return new PendingMailWidget(conf);
            case (dto.WidgetKind.Scanning): return new ScanningWidget(conf);
            case (dto.WidgetKind.FinancialAssuranceInternal): return new FinancialAssuranceInternalWidget(conf);
            case (dto.WidgetKind.PendingPayments): return new PendingPaymentsWidget(conf);
            case (dto.WidgetKind.Wells): return new WellWidget(conf);
            case (dto.WidgetKind.ExternalChiefsOrdersStatus): return new ExternalChiefsOrdersStatusComponent(conf);
            case (dto.WidgetKind.OrgFiles): return new OrgFilesWidget(conf);
            case (dto.WidgetKind.PendingWellTransfer): return new PendingWellTransferWidgetComponent(conf);
            case (dto.WidgetKind.WellSellerTransfer): return new WellSellerTransferWidgetComponent(conf);
            case (dto.WidgetKind.InternalInspections): return new InspectionsInternalWidgetComponent(conf);
            case (dto.WidgetKind.ExternalUpcomingBondExpiration): return new ExternalUpcomingBondExpirationWidget(conf);
            case (dto.WidgetKind.InternalUpcomingBondExpiration): return new InternalUpcomingBondExpirationWidget(conf);
            case (dto.WidgetKind.WellBuyerTransfer): return new WellBuyerTransferWidgetComponent(conf);
            case (dto.WidgetKind.ExternalPayments): return new ExternalPaymentsWidget(conf);
            case (dto.WidgetKind.Notifications): return new NotificationsWidget(conf);
            case (dto.WidgetKind.Utility): return new UtilityWidgetComponent(conf);
            case (dto.WidgetKind.External7ATransfer): return new External7ATransferWidgetComponent(conf);
            case (dto.WidgetKind.Issues): return new IssuesWidget(conf);
            case (dto.WidgetKind.DataCorrections): return new DataCorrectionsWidget(conf);
            case (dto.WidgetKind.ExternalDataCorrectionRequests): return new DataCorrectionRequestsExternalWidget(conf);
            case (dto.WidgetKind.InternalDataCorrectionRequests): return new DataCorrectionRequestsInternalWidget(conf);
            case (dto.WidgetKind.PaperSubmissions): return new PaperSubmissionsWidget(conf);
            case (dto.WidgetKind.ExternalOrganizationManagement): return new OrganizationManagementExternalWidget(conf);
            case (dto.WidgetKind.InternalOrganizationManagement): return new OrganizationManagementInternalWidget(conf);
            case (dto.WidgetKind.InternalComplianceReport): return new ComplianceReportInternalView(conf);
            case (dto.WidgetKind.ExternalComplianceReport): return new ComplianceReportExternalView(conf);
            case (dto.WidgetKind.ExternalIssues): return new ExternalIssuesView(conf);
            case (dto.WidgetKind.WellSearch): return new WellSearchView(conf);
            case (dto.WidgetKind.LandownerPassthrough): return new LandownerPassthroughView(conf);
            default: {break;}
        }    
    }

    constructor(conf: any) {
        this.init(conf);
    }

    init(conf: any): void {
        Object.assign(this, conf);
    }
}

export class NotificationsWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Notifications;
    public title: string = "Notifications";
}

export class ExternalPaymentsWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalPayments;
    public title: string = "Payments";
}

export class WellWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Wells;
    public title: string = "Wells";
}

export class ChartWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Chart;
    public title: string = "Chart";
}

export class GridWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Grid;
    public title: string = "Grid";
}

export class MapWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Map;
    public title: string = "Map";
}

export class WorkOrderWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.WorkOrder;
    public title: string = "Work Orders";
}

export class FullCalendarWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.FullCalendar;
    public title: string = "Full Calendar";
}

export class ListCalendarWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ListCalendar;
    public title: string = "Calendar List";
}

export class RegistrationRequestWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.RegistrationRequest;
    public title: string = "Pending Registrations";
}

export class PermitsWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Permits;
    public title: string = "Permit Requests";
}

export class FinancialAssuranceWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.FinancialAssurance;
    public title: string = "Financial Assurance";
}

export class ExternalPermitWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalPermit;
    public title: string = "Applications, Permits, and Authorizations";
}

export class ExternalWorkOrder extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalWorkOrder;
    public title: string = "Work Orders";
}

export class ScanningWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Scanning;
    public title: string = "Scanning";
}

export class PendingMailWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.PendingMail;
    public title: string = "Pending Certified and Standard Mail";
}

export class FinancialAssuranceInternalWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.FinancialAssuranceInternal;
    public title: string = "Financial Assurance";
}

export class PendingPaymentsWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.PendingPayments;
    public title: string = "Pending Payments";
}
export class ExternalChiefsOrdersStatusComponent extends Widget{
    component: dto.WidgetKind = dto.WidgetKind.ExternalChiefsOrdersStatus;
    public title: string = "Chiefs Orders";
}
export class OrgFilesWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.OrgFiles;
    public title: string = "Organization Files";
}
export class PendingWellTransferWidgetComponent extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.PendingWellTransfer;
    public title: string = "Pending Well Transfers";
}
export class WellSellerTransferWidgetComponent extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.WellSellerTransfer;
    public title: string = "Well Transfer Seller";
}

export class InspectionsInternalWidgetComponent extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.InternalInspections;
    public title: string = "Pending Inspections";
}

export class ExternalUpcomingBondExpirationWidget extends Widget{
    component: dto.WidgetKind = dto.WidgetKind.ExternalUpcomingBondExpiration;
    public title :string = "Upcoming Expiring Financial Assurance";
}
export class InternalUpcomingBondExpirationWidget extends Widget{
    component: dto.WidgetKind = dto.WidgetKind.InternalUpcomingBondExpiration;
    public title :string = "Upcoming Expiring Financial Assurance";
}

export class InternalUpcomingInsuranceExpirationWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.InternalUpcomingInsuranceExpiration;
    public title: string = "Upcoming Expiring Insurance Policies";
}

export class WellBuyerTransferWidgetComponent extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.WellBuyerTransfer;
    public title: string = "Well Transfer Buyer";
}
export class UtilityWidgetComponent extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Utility;
    public title: string = "Set Dates to test Return/Deny features";
}

export class External7ATransferWidgetComponent extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.External7ATransfer;
    public title: string = "7A Transfer";
}

export class IssuesWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.Issues;
    public title: string = "Issues";
}

export class DataCorrectionsWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.DataCorrections;
    public title: string = "Admin Data Corrections";
}

export class DataCorrectionRequestsInternalWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.InternalDataCorrectionRequests;
    public title: string = "External Data Correction Requests - Internal";
}


export class DataCorrectionRequestsExternalWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalDataCorrectionRequests;
    public title: string = "Data Correction Requests";
}


export class PaperSubmissionsWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.PaperSubmissions;
    public title: string = "Paper Submissions";
}


export class OrganizationManagementExternalWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalOrganizationManagement;
    public title: string = "Organization Management";
}

export class OrganizationManagementInternalWidget extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.InternalOrganizationManagement;
    public title: string = "Organization Management";
}

export class ComplianceReportInternalView extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.InternalComplianceReport;
    public title: string = "Post-Drill Compliance Reports";
}

export class ComplianceReportExternalView extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalComplianceReport;
    public title: string = "Post-Drill Compliance Reports";
}

export class ExternalIssuesView extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.ExternalIssues;
    public title: string = "Issues";
}

export class WellSearchView extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.WellSearch;
    public title: string = "Well Search";
}

export class LandownerPassthroughView extends Widget {
    component: dto.WidgetKind = dto.WidgetKind.LandownerPassthrough;
    public title: string = "Landowner Passthrough Program";
}

export class OrgModel {
    orgName: string = "";
    orgId: string = "";
}